
import React, { SyntheticEvent, useMemo, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CopyToClipboard from 'react-copy-to-clipboard';
import { DUImage } from './pages/types/DUImage';
import { apiRequest } from '../utils/authConfig';
import { useMsal, account } from '../utils/authContext';
import LoadingButton from '../common/LoadingButton';
import { getFileName, getTokenAndFetchHeaders } from '../utils';

const DisplayMeta = ({ url }: { url: string }) => {
    const name = getFileName(url);
    return (
        <small style={{ display: "block", textAlign: "center", position: "absolute", bottom: 0, padding: "0.5em 1em", backgroundColor: "rgba(0,0,0, 0.5)", zIndex: 10, width: "100%", color: "#fff" }}>{name}</small>
    );
}

const ImageCard = (props: any) => {
    const args = useMemo(() => ({ ...apiRequest, account }), []);
    const { getToken } = useMsal();
    const [deleting, setDeleting] = useState(false);
    const [copied, setCopied] = useState(false);
    const image: DUImage = props.image;

    const addDefaultSource = (evt: SyntheticEvent<HTMLImageElement>) => {
        if (evt.currentTarget.src === image.original) {
            return;
        }
        evt.currentTarget.src = image.original;
    }

    const deleteImage = async (fileName: string) => {
        const api = process.env['REACT_APP_BACKEND_URL'];
        const apiKey = process.env.REACT_APP_BACKEND_KEY ? process.env.REACT_APP_BACKEND_KEY : '';
        const nameParts = fileName.split('%2F');
        let fileNameParam;
        nameParts.shift();
        if (nameParts.length) {
            fileNameParam = nameParts.join('%2F');
        } else {
            fileNameParam = '%2F' + fileName;
        }
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        await fetch(`${api}/image?fileId=${fileNameParam}`, {
            method: 'DELETE',
            headers,
        });
    }

    const handleDelete = async (fileName: string, folder: string) => {
        try {
            setDeleting(true);
            await deleteImage(`${folder}/${fileName}`);
            await props.onDelete();
        } catch (err: any) {
            setDeleting(false);
            props.onError(err);
        }
    };

    const handleDeleteClick = async () => {
        const imgPath = image.original.replace(/https:\/\/[a-z\w.]*\//, '');
        const parts = imgPath.split('/');
        const fileId = parts.pop() || '';
        const folder = parts.join('/')
        await handleDelete(fileId, folder);
    };

    return <Card style={{ width: '216px', display: "inline-block" }} className="me-2 mb-2">
        <div style={{ width: "216px", height: "216px", overflow: "hidden", position: "relative", cursor: "pointer" }}>
            <img onError={addDefaultSource} className="m-auto" alt={`Thumbnail - ${image.thumbnail}`} src={image.thumbnail} style={{ maxHeight: "202px", maxWidth: "202px", position: "absolute", top: "0", left: "0", bottom: "0", right: "0" }} />
            <DisplayMeta url={image.original} />
        </div>
        <Card.Footer className="p-2 clearfix">
            <LoadingButton
                loading={deleting}
                variant="danger"
                className="float-end"
                size="sm"
                onClick={handleDeleteClick}
            >Delete</LoadingButton>
            <CopyToClipboard text={image.zoom} onCopy={() => setCopied(true)}>
                <Button variant="outline-info" size="sm">{!copied ? <span>Copy URL</span> : <span>Copied!</span>} <FontAwesomeIcon icon="copy" /></Button>
            </CopyToClipboard>
        </Card.Footer>
    </Card>
}
export default ImageCard;
